import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../HomePage.css";
import { activeManagers } from "../managersData";

const chrisBode = activeManagers.find(m => m.manager === "Nick Criss");

const navItems = [
    { label: "Home", path: "/" },
    { label: "Managers", path: "/managers" },
    { label: "Seasons", path: "/seasons" },
    { label: "League Settings", path: "/league-settings" },
];
// Matchup data for 2024 season
const matchups2024 = [
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },

    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
];

const NickCriss = () => {
    return (
        <div className="homepage-container">
            {/* Header */}
            <header className="header">
                <nav className="nav-bar">
                    {navItems.map(({ label, path }, i) => (
                        <Link key={i} to={path} className="nav-link" tabIndex={0}>
                            {label}
                        </Link>
                    ))}
                </nav>
            </header>

            {/* Title */}
            <motion.h1
                className="footballin-title"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.6 }}
            >
                Dave Criss - Dave's Duds
            </motion.h1>

            {/* Side-by-side cards */}
            <main
                className="main-content"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    justifyContent: "center",
                    width: "75%",
                    margin: "2rem auto",
                }}
            >
                {/* Top two sections: About & Notable Stats */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <h2 className="section-title">📘 About</h2>
                        <p>
                            Manager of the team <strong>Dave's Duds</strong>.<br />
                            Alternate Names: <em>N/A</em>
                        </p>
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                    >
                        <h2 className="section-title">📊 Notable Stats</h2>
                        <p>
                            <strong>Overall Record:</strong> 16-12-0<br />
                            <strong>Championship Record:</strong> 0-1<br />
                            <strong>2024–2025:</strong> 11-3-0<br />
                            <strong>2025–2026:</strong> 0-0-0
                        </p>
                    </motion.section>
                </div>




                {/* New section: 2023-2024 Season header */}
                <h2 className="section-title" style={{ textAlign: "center", marginTop: "2rem" }}>
                    2024-2025 Season
                </h2>

                {/* Season two side-by-side sections */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        <h2 className="section-title">📝 Draft Picks</h2>
                        {chrisBode.draftPicks[2024].length ? (
                            <ul>
                                {chrisBode.draftPicks[2024].map((pick, idx) => (
                                    <li key={idx}>
                                        Round {pick.round} - Pick {pick.pick} - {pick.player} - {pick.team}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No draft picks recorded for 2023.</p>
                        )}
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                    >
                        <h2 className="section-title">📈 Team & Stats</h2>

                        <div className="team-stats">
                            <p><strong>Rank:</strong> #2</p>
                            <p><strong>Season Record:</strong> 11-3-0</p>
                            <p><strong>Points for: </strong>2134.15</p>
                            <p><strong>Points against: </strong>1912.65</p>
                            <p><strong>Average PPG: </strong>152.4</p>
                            <p><strong>Average Opponent PPG: </strong>136.6</p>
                            <p><strong>Team moves: </strong>64</p>
                        </div>

                        <hr style={{ margin: '1.5rem 0' }} />

                        <div className="ending-team">
                            <h3>Ending Team</h3>
                            <p><strong>QB:</strong> Jared Goff, Brock Purdy</p>
                            <p>
                                <strong>RB:</strong> Jahmyr Gibbs, De'Von Achane, Alexander Mattison
                            </p>
                            <p>
                                <strong>WR:</strong> Adam Thielen, Jalen McMillan, Malik Nabers, CeeDee Lamb, Jaylen Waddle, Nico Collins, Jake Bobo, Rashee Rice (IR)
                            </p>
                            <p>
                                <strong>TE:</strong> Chig Okonkwo, Dalton Schultz
                            </p>
                            <p><strong>D/ST:</strong> Dolphins, Bills</p>
                            <p><strong>K:</strong> Will Reichard</p>
                        </div>
                    </motion.section>
                </div>

                {/* Matchup grid below draft picks and team & stats */}
                <motion.section
                    className="matchup-grid card"
                    style={{ marginTop: "2rem", padding: "1rem" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(9, 1fr)",  // 9 columns equal width
                            gridAutoRows: "auto",
                            gap: "0.5rem",
                            width: "100%", // full width of parent container
                        }}
                    >
                        {matchups2024.map(({ opponent, pointsFor, pointsAgainst }, index) => {
                            const won = pointsFor > pointsAgainst;
                            const weekNumber = index + 1; // week number 1-18
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: won ? "#d4edda" : "#f8d7da",
                                        border: `1px solid ${won ? "#155724" : "#721c24"}`,
                                        borderRadius: "6px",
                                        padding: "0.5rem",
                                        fontSize: "0.8rem",
                                        textAlign: "center",
                                        color: won ? "#155724" : "#721c24",
                                        userSelect: "none",
                                        minWidth: 0,
                                    }}
                                >
                                    <div>Week {weekNumber}:</div>
                                    <div>vs. {opponent}</div>
                                    <div>
                                        {pointsFor} - {pointsAgainst}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </motion.section>
            </main>

            {/* Footer */}
            <footer className="footer">Created by Nick Criss ⚡️</footer>
        </div>
    );
};

export default NickCriss;
